import ChatCenterPanel from './ChatCenterPanel';

export { type ChatRef } from './ChatCenterPanel';

export default ChatCenterPanel;
